export const GALLERY_CATEGORIES = [
  { id: 'all', label: 'All Highlights' },
  { id: 'expo', label: 'Career Expo' },
  { id: 'fair', label: 'Career Fairs' },
  { id: 'workshop', label: 'Workshops' },
  { id: 'networking', label: 'Networking' }
];

export const GALLERY_CATEGORY_OPTIONS = GALLERY_CATEGORIES.filter((cat) => cat.id !== 'all');

export const GALLERY_SIZE_OPTIONS = [
  { id: 'normal', label: 'Medium (default)' },
  { id: 'wide', label: 'Wide' },
  { id: 'tall', label: 'Tall' }
];
